<template>
	<section
		class="cms-hero-block"
		:style="sectionStyle"
	>
		<div class="cms-hero-block__content" :style="contentStyle">
			<h1 v-if="headline" class="cms-hero-block__headline">{{ headline }}</h1>
			<p v-if="resolvedSubheadline" class="cms-hero-block__subhead">{{ resolvedSubheadline }}</p>
			<a
				v-if="buttonText"
				:href="buttonUrl || '#'"
				class="cms-hero-block__btn"
			>{{ buttonText }}</a>
		</div>
	</section>
</template>

<script>
/**
 * HeroBlock.vue
 * ─────────────
 * Hero banner: headline, subheadline, optional CTA button, content
 * alignment. Background image/color, light/dark theme, padding and
 * border all come from the wrapper style traits (Background & Theme,
 * Spacing, Border) so padding never pushes the background inward.
 */

export default {
	name: 'HeroBlock',

	props: Object.assign(
		{},
		{
			headline: {
				type: String,
				default: ''
			},
			subheadline: {
				type: String,
				default: ''
			},
			buttonText: {
				type: String,
				default: ''
			},
			buttonUrl: {
				type: String,
				default: ''
			},
			alignment: {
				type: String,
				default: 'center',
				validator: function (val) {
					return ['left', 'center', 'right'].indexOf(val) !== -1;
				}
			}
		}
	),

	computed: {
		resolvedSubheadline: function () {
			return this.subheadline || '';
		},



		sectionStyle: function () {
			return { textAlign: this.alignment };
		},

		contentStyle: function () {
			return { position: 'relative', zIndex: 1 };
		}
	}
};
</script>

<style scoped>
.cms-hero-block {
	position: relative;
	width: 100%;
	max-width: 100%;
	color: inherit;
}

.cms-hero-block__content {
	max-width: 800px;
	margin: 0 auto;
}

.cms-hero-block[style*="text-align: left"] .cms-hero-block__content,
.cms-hero-block[style*="text-align:left"] .cms-hero-block__content {
	margin-left: 0;
	margin-right: auto;
}

.cms-hero-block[style*="text-align: right"] .cms-hero-block__content,
.cms-hero-block[style*="text-align:right"] .cms-hero-block__content {
	margin-left: auto;
	margin-right: 0;
}

.cms-hero-block__headline {
	margin: 0 0 0.75rem 0;
	font-size: 2.5em;
	font-weight: 700;
	line-height: 1.2;
	text-transform: none;
}

.cms-hero-block__subhead {
	margin: 0 0 1.5rem 0;
	font-size: 1.15em;
	opacity: 0.85;
	line-height: 1.6;
}

.cms-hero-block__btn {
	display: inline-block;
	padding: 0.7rem 2rem;
	font-weight: 600;
	font-size: 1em;
	text-decoration: none;
	border-radius: 4px;
	transition: opacity 0.15s;
	cursor: pointer;
	background-color: var(--theme-accent, var(--site-accent-color, #FB6A00));
	color: #FFFFFF;
}

.cms-hero-block__btn:hover {
	opacity: 0.85;
}

@media (max-width: 768px) {
	.cms-hero-block__headline {
		font-size: 1.75em;
	}

	.cms-hero-block__subhead {
		font-size: 1em;
	}
}
</style>
